module.exports = __webpack_public_path__ + "static/media/22-iveco-mercedes.186cc4bb.jpg";